import { render, staticRenderFns } from "./incident-alerts.vue?vue&type=template&id=4f76371c&scoped=true&"
import script from "./incident-alerts.vue?vue&type=script&lang=js&"
export * from "./incident-alerts.vue?vue&type=script&lang=js&"
import style0 from "./incident-alerts.vue?vue&type=style&index=0&id=4f76371c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f76371c",
  null
  
)

export default component.exports